/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Actor } from './Actor';
import { Events } from '../interaction/Events';
import { Clock, AnimationMixer, AnimationClip, LoopOnce } from 'three';
/**
 * Actor that do a complex animation
 */
export class SequenceActor extends Actor {
    /**
     * constructor
     * @param scene the scene where to do the animation
     * @param desc the animation description
     */
    constructor(scene, desc) {
        super();
        this.clock = new Clock();
        const obj = scene.getObjectById(desc.objectId);
        const clip = AnimationClip.parse(desc.action);
        this.mixer = new AnimationMixer(obj);
        this.mixer.addEventListener('finished', (() => {
            scene.getStage().dispatchEvent(Events.ACTORFINISHED, { detail: { id: desc.objectId, name: desc.action.name } });
            this.discontinue();
        }).bind(this));
        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(LoopOnce, 1);
    }
    /**
     * see base class
     */
    update() {
        this.mixer.update(this.clock.getDelta());
    }
    /**
     * see base class
     */
    start() {
        this.clock.start();
        this.action.play();
    }
    /**
     * see base class
     */
    stop() {
        this.action.stop();
        this.clock.stop();
    }
}
//# sourceMappingURL=SequenceActor.js.map